<template>
  <div class="cardlist">
  	<div class="cardlist-title">
			<label>{{category}}</label>
	</div>
  <div class="cardlist-dropdown">
    <Select
      :placeholder="selections().length ? '' : `Select ${category}`"
      :multiple="multiple"
      popper-class="selectdropdown is-multi-select"
      filterable
      :clearable="false"
      :default-first-option="true"
      v-model="selectedValues"
      :collapse-tags="true"
      :collapse-tags-tooltip="true"
      :max-collapse-tags="1"
      size="mini"
      class="select-default no-tags"
    >
        <OptionGroup v-for="(group,groupIndex) in groups" :key="group.label">
          <Checkbox class="checkbox-parent" v-model="group.isSelected"  :indeterminate="isIndeterminate(group)" @change="setParentGroup(group);">
            {{ group.label }}
          </Checkbox>
          <Option
            v-for="item in group.options"
            :key="item.id" 
            :label="item.name"
            :value="item.id"
            class="pl-30"
          >
            <Checkbox 
            class="text-ellipsis"
            :title="item.name"
            :value="item.isSelected"
            @change="toggle(item, group, groupIndex)">
              {{ item.name }}
            </Checkbox>
          </Option>
        </OptionGroup>
      </Select>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedValues: []
    };
  },
  props: {
    selected: {},
    category: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    isDarkTheme: { 
      type: Boolean,
      default: false,
    },
    groups: {
        type: Array,
        default: () => [],
    },
    idLabel: {
      type: String,
      default: 'id',
    }
  },
  computed: {
    isIndeterminate() {
      return (group) => {
        const selectedOptions = group.options.filter((item) => item.isSelected);
        return selectedOptions.length > 0 && selectedOptions.length < group.options.length;
      };
    },
    allSelected() {
      return (group) => {
        const selectedOptions = group.options.filter((item) => item.isSelected);
        return selectedOptions.length === group.options.length;
      };
    },
    selections() {
      return () => {
        let selections = [];
        this.groups.forEach((group) => {
            if(group.isSelected) {
                selections.push(...group.options.map(option => option.id));
            } else {   
                let selectedSub = group.options.filter((item) => item.isSelected);
                selections.push(...selectedSub.map(option => option.id));
            }
        });
        return selections || [];
      };
    },
    darkTheme() {
      return this.isDarkTheme ? 'dropdown-dark' : 'selectdropdown';
    }
  },
  methods: {
     setParentGroup(group) {
        if(this.isIndeterminate(group) || group.isSelected) {
            group.options.forEach((data, index) => {
                if(group.options[index]) {
                  group.options[index].isSelected = true;
                }
            });
        } else {
          group.options.forEach((data, index) => {
                  if(group.options[index]) {
                    group.options[index].isSelected = false;
                  }
          });
        }
        if(!this.selections().length) {
           this.groups[0].options[0].isSelected = true;
            if(this.groups[0].options.length === 1) {
              this.groups[0].isSelected = true; 
            }
        }
       this.$emit('updateOption', this.selections());
       this.selectedValues = this.selections();
       this.$forceUpdate();
     },
     reset() {
        this.groups.forEach((group) => {
          group.options.forEach((data, index) => {
            group.isSelected = false;
             group.options[index].isSelected = false;
             if(!this.selections().length) {
                this.groups[0].options[0].isSelected = true;
                if(this.groups[0].options.length === 1) {
                  this.groups[0].isSelected = true; 
                }
              }
          });
         this.selectedValues = this.selections();
        });
        return true;
     },
     toggle(item, group, groupIndex) {
        item.isSelected = !item.isSelected; 
        this.groups[groupIndex].isSelected = this.allSelected(group);
        if(!this.selections().length) {
           this.groups[0].options[0].isSelected = true;
           if(this.groups[0].options.length === 1) {
                  this.groups[0].isSelected = true; 
           }
        }
        this.$emit('updateOption', this.selections());
        this.selectedValues = this.selections();
        this.$forceUpdate();

     }
  },
  mounted() {
    this.selectedValues = [];
    this.selected.forEach(data =>{
         this.selectedValues.push(data[this.idLabel]);
    });
    this.groups[0].options[0].isSelected = true;
    if(this.groups[0].options.length === 1) {
        this.groups[0].isSelected = true; 
    }
  },

};
</script>
<style lang="scss">
 .checkbox-parent {
    background: rgb(238, 242, 244);
    width: 100%;
    font-weight: 800;
    padding: 10px 4px;
}

.no-tags {
  .el-select {
     &__tags {
       .el-tag {
         &__close {
              display:none;
              pointer-events: none;
         }
       }
      &-text {
        color: #404040;
      }

     }

  }
}

.is-multi-select{
    .el-select{
        &-group__title {
            display: none;
        }
        &-dropdown__item{
            font-size:12px;
            font-weight: 700;
            color: #404040;
            padding-left:25px;
            .el-checkbox__label{
              font-size:12px;
              font-weight: 700;
              color: #404040;
              max-width: 95%;
              display: inline-block;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
        }
        &-dropdown__empty {
              font-size:12px;
              font-weight: 700;
              color: #404040;
        }
    }
    .checkbox-parent{
        font-size:12px;
        font-weight: 700;
        color: #404040;
    }

}
</style>
